import { Reveal } from "./Reveal";
import { useLanguage } from "../i18n/LanguageContext";
import { PARCEIROS_INSTITUCIONAIS } from "../data/parceiros";

export const ParceirosInstitucionais = () => {
    const { t } = useLanguage();
    return (
        <section className="relative z-10 -mt-8 sm:-mt-12 py-10 sm:py-12" data-testid="parceiros-section">
            <div className="mx-auto max-w-[1500px] px-5 sm:px-10">
                <Reveal>
                    <div className="flex items-center justify-center gap-4 sm:gap-5">
                        <span className="hidden sm:block h-px flex-1 max-w-56 bg-gradient-to-l from-[#c9a24b]/60 to-transparent" />
                        <span className="hidden sm:block w-1.5 h-1.5 rotate-45 border border-[#c9a24b]" />
                        <h2 className="font-caps gold-text text-lg sm:text-xl tracking-[0.2em] text-center" data-testid="parceiros-title">
                            {t.parceiros.titulo}
                        </h2>
                        <span className="hidden sm:block w-1.5 h-1.5 rotate-45 border border-[#c9a24b]" />
                        <span className="hidden sm:block h-px flex-1 max-w-56 bg-gradient-to-r from-[#c9a24b]/60 to-transparent" />
                    </div>
                    <div className="flex justify-center mt-2">
                        <img loading="lazy" decoding="async" src="/images/ornamento.webp" alt="" aria-hidden="true" className="w-44 opacity-90" />
                    </div>
                </Reveal>

                <Reveal delay={0.15}>
                    <div className="mt-8 flex flex-wrap items-start justify-center gap-x-20 gap-y-8" data-testid="parceiros-grid">
                        {PARCEIROS_INSTITUCIONAIS.map((p) => (
                            <div key={p.id} className="flex flex-col items-center gap-3" data-testid={`parceiro-${p.id}`}>
                                <img loading="lazy" decoding="async" src={p.logo} alt={p.nome}
                                    className="h-20 sm:h-24 w-auto object-contain" data-testid={`parceiro-${p.id}-logo`} />
                                <p className="font-display font-light text-base text-[#efe6d6] text-center">{p.nome}</p>
                                <p className="font-caps text-[9px] tracking-[0.25em] uppercase text-[#c9a24b]/80 text-center -mt-1.5">{t.assoc.parceiros[p.tituloKey]}</p>
                            </div>
                        ))}
                    </div>
                </Reveal>
            </div>
        </section>
    );
};
